<script>
	import { SyncLoader } from "svelte-loading-spinners";
</script>

<div class="d-flex justify-content-center align-items-center">
	<SyncLoader size="40" color="orange" unit="px" duration="1s" />
</div>
